import { CursorModule } from './directives/cursor/cursor.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogSnippetModule } from '@app/shared/components/catalog/catalog-snippet/catalog-snippet.module';
import { FollowButtonModule } from '@app/shared/components/follow-button/follow-button.module';
import { SimpleTextModalModule } from '@app/shared/components/simple-text-modal/simple-text-modal.module';
import { SizeGuideModalModule } from '@app/shared/components/size-guide-modal/size-guide-modal.module';
import { ConditionGuideModalModule } from '@app/shared/components/condition-guide-modal/condition-guide-modal.module';
import { SvgModule } from '@app/shared/components/svg/svg.module';
import { RefModule } from '@app/shared/components/ref/ref.module';
import { ModalPaymentInstallmentModule } from '@app/shared/components/modals/modal-payment-installment/modal-payment-installment.module';
import { MagnifyModule } from '@app/shared/directives/magnify/magnify.module';
import { SliderModule } from './components/slider/slider.module';
import { FileUploaderModule } from '@app/shared/components/file-uploader';
import { MaterialImportsModule } from '@app/material.module';
import { SharedPipesModule } from '@app/shared/pipes/shared-pipes.module';
import { AccordionModule } from './components/accordion/accordion.module';
import { SvgCartModule } from './components/svg/cart/svg-cart.module';
import { LikeModule } from './components/like/like.module';
import { MatDialogModule } from '@angular/material/dialog';
import { environment } from '@env/environment';
// Angular lib
import { VcAngularLibModule, ImageModule } from '@vestiaire/vc-angular-lib';
import { ObserveDirective } from './directives/observe/observe.directive';
import { AddToCartModule } from './directives/add-to-cart/add-to-cart.module';

@NgModule({
  imports: [
    CommonModule,
    SharedPipesModule,
    MatDialogModule,
    VcAngularLibModule.forRoot({ cmsApiUrl: `${environment.vccmsuri}/`, atlasApiUrl: `${environment.apiBaseUrl}/` }),
    ImageModule.forRoot({ imgPath: `${environment.vccmsimguri}` }),
    AddToCartModule
  ],
  exports: [
    CommonModule,
    SvgModule,
    SvgCartModule,
    CatalogSnippetModule,
    FollowButtonModule,
    SimpleTextModalModule,
    SizeGuideModalModule,
    ConditionGuideModalModule,
    RefModule,
    ModalPaymentInstallmentModule,
    MagnifyModule,
    AccordionModule,
    SliderModule,
    FileUploaderModule,
    MaterialImportsModule,
    CursorModule,
    ObserveDirective,
    SharedPipesModule,
    LikeModule,
    VcAngularLibModule,
    ImageModule
  ],
  declarations: [ObserveDirective],
  entryComponents: []
})
export class SharedModule {}
